import type { ConversationAgent, ConversationTurnStatus } from '@niuma/protocol';

export type SubmissionIntent = 'default' | 'steer';
export type SubmissionDisposition = 'sent' | 'queued' | 'steered';

export function conversationSubmitKey(
  agent: ConversationAgent | undefined,
  intent: SubmissionIntent,
): '\t' | '\r' {
  return agent === 'codex' && intent === 'default' ? '\t' : '\r';
}

export function expectedSubmissionDisposition(
  agent: ConversationAgent | undefined,
  turnStatus: ConversationTurnStatus | 'unknown',
  intent: SubmissionIntent,
): SubmissionDisposition {
  if (intent === 'steer') return 'steered';
  return agent === 'codex' && turnStatus !== 'idle' ? 'queued' : 'sent';
}
